import type { SVGProps } from 'react';
const SvgPhotoCameraFront = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#photo_camera_front_svg__a)">
      <path
        fill="currentColor"
        d="m18 10.48 4-3.98v11l-4-3.98V18c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v4.48Zm-2-.79V6H4v12h12V9.69ZM10 12c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2Zm0 1c1.34 0 4 .67 4 2v1H6v-1c0-1.33 2.66-2 4-2Z"
      />
    </g>
    <defs>
      <clipPath id="photo_camera_front_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPhotoCameraFront;
